/** A touch-only device: a coarse primary pointer and no fine pointer anywhere (spec §5). */
export const COARSE = '(pointer: coarse)';
export const FINE = '(any-pointer: fine)';

export function media(query: string): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;
}

export function isTouchOnlyDevice(): boolean {
  return (media(COARSE)?.matches ?? false) && !(media(FINE)?.matches ?? false);
}
